import { TThunkAction } from '../../types/redux';
import {
  fetchSetAnswerReactionWeb,
  TSetAnswerReactionWebResponse,
} from '../../repositories/newbuilding-reviews/v1/set-answer-reaction-web';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_answer_reaction/SetAnswerReactionRequest';
import { EStatus } from '../../types/likes';
import { setAnswerReactionAction } from './actions';
import { mapLabelFromState, trackReactionAnalyticClick } from './analytics/reactionAnalytic';
import { getAnswerById } from '../../selectors/answers';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { ISetAnswerReactionWebResponse } from '../../repositories/newbuilding-reviews/entities/set_answer_reaction/SetAnswerReactionWebResponse';

interface IParams {
  answerId: string;
  type: EStatus;
}

export function setAnswerReaction({ answerId, type }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const siteType = context.custom.deviceType;
      const state = getState();
      const { like } = getAnswerById(answerId)(state);
      const rating = getNewbuildingRating(state);
      const { response }: TSetAnswerReactionWebResponse = await fetchSetAnswerReactionWeb({
        httpApi,
        parameters: { answerId, type: type as unknown as EType },
      });
      const label = mapLabelFromState({
        currentState: like.status,
        nextState: (response as ISetAnswerReactionWebResponse).type as unknown as EStatus,
      });
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          review_id: answerId,
          type: 'answer',
        },
      };
      trackReactionAnalyticClick({ label, page });

      dispatch(
        setAnswerReactionAction({
          answerId,
          type: (response as ISetAnswerReactionWebResponse).type as unknown as EStatus,
        }),
      );

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'answers#setAnswerReaction',
        message: error.message,
      });

      return false;
    }
  };
}
